module.exports = function() {
  return new Worker(__webpack_public_path__ + "adfe6c50f9d0c0dbf99e.worker.js");
};